import { render, staticRenderFns } from "./SupportList.vue?vue&type=template&id=37dcad00&scoped=true"
import script from "./SupportList.vue?vue&type=script&lang=js"
export * from "./SupportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dcad00",
  null
  
)

export default component.exports